export const TOASTER_ID = 'b2c-domru_toaster';

export const TOAST_TRAVEL_DISTANCE = 60;

export const TOAST_HIDE_AFTER_EXPIRATION = 5;

export const TOAST_SHOW_DURATION = 1;
export const TOAST_HIDE_DURATION = .5;
export const TOAST_SLIDE_DURATION = 1;
